// 액세스 토큰 보관 (IMP-6c)
//
// **리프레시 토큰은 여기에 없다.** httpOnly 쿠키로만 오간다 —
// JavaScript가 읽을 수 없으므로 XSS로도 꺼내갈 수 없다(백엔드 RefreshTokenCookie).
//
// 액세스 토큰만 sessionStorage에 둔다. Authorization 헤더에 실어야 해서 JS가 읽어야 하고,
// 수명이 30분이라 탈취되더라도 창이 짧다. 로그아웃하면 서버가 즉시 차단한다.
const ACCESS_KEY = "taplink.accessToken";

export function getToken(): string | null {
  return sessionStorage.getItem(ACCESS_KEY);
}

export function setToken(accessToken: string): void {
  sessionStorage.setItem(ACCESS_KEY, accessToken);
}

export function clearToken(): void {
  sessionStorage.removeItem(ACCESS_KEY);
}

/**
 * CSRF 토큰 — 서버가 `XSRF-TOKEN` 쿠키로 내려준다(httpOnly 아님, 읽을 수 있어야 하므로).
 *
 * 쿠키를 읽어 헤더로 되돌려 보내는 double-submit 방식이다.
 * 다른 사이트는 동일 출처 정책 때문에 이 쿠키를 읽을 수 없어 헤더를 만들지 못한다.
 */
export function getCsrfToken(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}
